/**
 * Voluum enum value tables — single source of truth for runtime checks.
 * Mirrors inline enums in `docs/voluum-api.json`.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

export const PREDICATE_VALUES = ['MUST_BE', 'MUST_NOT_BE'] as const;

export const AUTO_OPTIMIZATION_MODE_VALUES = [
  'OFFER',
  'LANDER',
  'INDEPENDENT',
  'DEPENDENT',
] as const;

export const CALCULATION_METHOD_VALUES = ['ROI', 'EPV', 'CVR', 'AUTO'] as const;

export const SORT_ORDER_VALUES = ['ASC', 'DESC'] as const;

export const PATH_REALTIME_ROUTING_VALUES = ['DISABLED', 'ENABLED'] as const;

export const FLOW_REALTIME_ROUTING_VALUES = [
  'DISABLED',
  'ENABLED',
  'PATHS',
] as const;

export const OFFER_REDIRECT_MODE_VALUES = [
  'REGULAR',
  'HTML',
  'DOUBLE_HTML',
  'REDIRECTLESS',
] as const;

export const DEVICE_TYPE_VALUES = [
  'DESKTOP',
  'TABLET',
  'SMART_TV',
  'MOBILE',
] as const;

export const CONNECTION_TYPE_VALUES = [
  'BROADBAND',
  'WIRELESS',
  'XDSL',
  'CABLE',
  'DIALUP',
  'MOBILE',
  'SATELLITE',
  'UNKNOWN',
  'WIRED',
  'WIFI',
] as const;

export const WEEKDAY_VALUES = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
] as const;

export const CUSTOM_VARIABLE_MATCHER_VALUES = ['EQUALS', 'CONTAINS'] as const;
